
import AttendMonthlyList from './AttendMonthlyList';

export default AttendMonthlyList;
